import { render } from "./Debugger.vue?vue&type=template&id=664e7f6e"
import script from "./Debugger.vue?vue&type=script&lang=ts"
export * from "./Debugger.vue?vue&type=script&lang=ts"

import "./Debugger.vue?vue&type=style&index=0&id=664e7f6e&lang=scss"
script.render = render

export default script